import 'popper.js';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-select';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';

import $ from 'jquery';
import React from 'react';

class BootstrapSelect extends React.Component {
  shouldComponentUpdate() {
    return true;
  }

  componentDidMount() {
    let passing = {
      style: '',
      styleBase: 'form-control',
      width: 'auto',
    };
    if (this.props['data-live-search']) {
      passing['liveSearch'] = this.props['data-live-search'];
    }
    if (this.props['data-size']) {
      passing['size'] = this.props['data-size'];
    }
    if (this.props['el-width']) {
      passing['width'] = this.props['el-width'];
    }

    this.$node = $(this.node);
    this.$node.selectpicker(passing);

    this.handleChange = this.handleChange.bind(this);
    this.$node.on('change', this.handleChange);
  }

  componentWillUnmount() {
    this.$node.off('change', this.handleChange);
    this.$node.selectpicker('destroy');
  }

  handleChange(e) {
    this.props.onChange(e);
  }

  componentDidUpdate(prevProps) {
    let isValid = this.props['is-valid'];

    if (
      typeof this.props.value === 'string' &&
      (this.props.value !== prevProps.value || this.props.children !== prevProps.children)
    ) {
      this.val(this.props.value);
      this.refresh();
    }

    if (typeof isValid === 'undefined') {
      return;
    }

    if (isValid === true) {
      this.$node.selectpicker('setStyle', 'is-valid');
    } else if (isValid === false) {
      this.$node.selectpicker('setStyle', 'is-invalid');
    } else if (isValid == null) {
      this.$node.selectpicker('setStyle', 'is-valid', 'remove');
      this.$node.selectpicker('setStyle', 'is-invalid', 'remove');
    }
  }

  refresh() {
    this.$node.selectpicker('refresh');
  }

  val(value) {
    this.$node.selectpicker('val', value);
  }

  render() {
    return (
      <div
        className={
          'w-100 ' +
          (this.props['is-valid'] === true ? ' is-valid' : this.props['is-valid'] === false ? ' is-invalid' : '')
        }
      >
        <select
          defaultValue={this.props.value}
          multiple={this.props.multiple ? true : false}
          className="selectpicker"
          ref={el => (this.node = el)}
        >
          {this.props.children}
        </select>
      </div>
    );
  }
}

export default BootstrapSelect;
